import {
  Navigate,
  Outlet,
  ScrollRestoration,
  createBrowserRouter,
} from "react-router-dom";
import Landing from "./components/Landing/Landing";
import Terms from "./components/Terms/Terms";
import Refunds from "./components/Refunds/Refunds";
import Balance from "./components/Balance/Balance";
import Docs from "./components/Docs/Docs";
import {
  Authentication,
  Endpoints,
  Errors,
  Glossary,
  Limits,
  Overview,
  Quickstart,
} from "./components/Docs/pages";

const RootLayout = () => {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <Landing /> },
      { path: "/terminos", element: <Terms /> },
      { path: "/refunds", element: <Refunds /> },
      // YOSHI-10464: the developer portal of the public Yoshi API. Its subsections are children
      // of /docs so they all share the sidebar, and they are declared before the catch-all: an
      // unknown path under /docs falls back to the portal index instead of leaving the site.
      {
        path: "/docs",
        element: <Docs />,
        children: [
          { index: true, element: <Overview /> },
          { path: "quickstart", element: <Quickstart /> },
          { path: "authentication", element: <Authentication /> },
          { path: "endpoints", element: <Endpoints /> },
          { path: "errors", element: <Errors /> },
          { path: "glossary", element: <Glossary /> },
          { path: "limits", element: <Limits /> },
          { path: "*", element: <Navigate to="/docs" replace /> },
        ],
      },
      { path: "*", element: <Navigate to="/" replace /> },
      { path: "/balance", element: <Balance /> },
    ],
  },
]);
